import { useEffect, useState } from 'react';
import api from '../components/wrapper/API';

const POLL_INTERVAL_MS = 30_000;

/** Event, das ein sofortiges Neuladen des Registrierungs-Badges auslöst.
 *  Wird von der Registrierungs-Seite nach Annehmen/Ablehnen gefeuert, damit
 *  der Badge nicht erst beim nächsten Poll-Intervall aktualisiert. */
export const REGISTRATIONS_CHANGED_EVENT = 'aveorga:registrations-changed';

/** Helfer zum Auslösen des Events (vermeidet Magic-Strings an der Aufrufstelle). */
export function notifyRegistrationsChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(REGISTRATIONS_CHANGED_EVENT));
  }
}

/**
 * Holt regelmäßig den Count offener Anmeldungen für den Nav-Badge und reagiert
 * zusätzlich sofort auf das REGISTRATIONS_CHANGED_EVENT.
 * `enabled = false` schaltet alles ab (z.B. für Nicht-Admins).
 */
export default function useRegistrationsBadge({ enabled = true } = {}) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    let cancelled = false;

    const fetchCount = async () => {
      try {
        const res = await api.get('/Registration/PendingCount', { background: true });
        if (!cancelled) setCount(res.data?.count ?? 0);
      } catch {
        // Badge ist UX, kein Blocker.
      }
    };

    fetchCount();
    const id = setInterval(fetchCount, POLL_INTERVAL_MS);
    window.addEventListener(REGISTRATIONS_CHANGED_EVENT, fetchCount);

    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener(REGISTRATIONS_CHANGED_EVENT, fetchCount);
    };
  }, [enabled]);

  return count;
}
